import { useState, type FormEvent } from "react";
import { login, type AuthUser } from "../lib/api";
import { Button, ErrorNote, Input } from "../components/ui";

export function Login({ onLogin }: { onLogin: (user: AuthUser) => void }) {
  const [email, setEmail] = useState("admin@example.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<unknown>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const user = await login(email, password);
      onLogin(user);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-50 p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex flex-col items-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-600 text-lg font-bold text-white">IP</div>
          <h1 className="mt-4 text-xl font-bold text-ink-900">Inbox Placement Platform</h1>
          <p className="mt-1 text-sm text-ink-500">Deliverability testing and sender reputation monitoring</p>
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-xl border border-ink-200 bg-white p-6 shadow-card">
          <div>
            <label className="mb-1.5 block text-xs font-medium text-ink-600">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-medium text-ink-600">Password</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" placeholder="••••••••" />
          </div>
          <ErrorNote error={error} />
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <p className="text-center text-xs text-ink-400">Demo: admin@example.com / Admin123!</p>
        </form>
      </div>
    </div>
  );
}
